import { lazy } from 'react'

export const ReachIdealWeight = lazy(() => import('./v1/ReachIdealWeight'))
export const ReachIdealWeightV2 = lazy(() => import('./v2/ReachIdealWeightV2'))
